(function () {
    //'use strict';

    angular
        .module('app')
        .controller('flashEditCosting', flashEditCosting);

        function flashEditCosting(
            $scope,
            $rootScope,
            $state,
            $q,
            $filter,
            CostingService,
            PrototypeService,
            SearchHelpService,
            BrandService,
            SeasonService,
            PatternService,
            SharedData,
            cfpLoadingBar,
            toaster,
            PdmServices,
            GridUtil,
            $stateParams) {

        var model = this;
            $scope.currentUserId = $rootScope.userId;
            $scope.isFactoryUser = $rootScope.isFactoryUser;
            
        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        model.init = function () {
            angular.forEach($rootScope.userPermissions,
                function (userPermissionRow) {
                    if (userPermissionRow[0] === 15) {
                        if (userPermissionRow[1] === 2) {
                            model.CostingEdit = true;
                        }
                    }
                });

            if (!model.CostingEdit) {
                $state.go('permissionDenied');
            }

            getPage();
            getOutsoleTechs();
            getCurrencies();
        };

        $scope.brands = [];
        $scope.seasons = [];
        $scope.genders = [];
        $scope.factories = [];
        $scope.outsoles = [];
        $scope.productTypes = [];
        $scope.divisions = [];
        $scope.documentInterface = {};
        $scope.massCostingMetaData = {};
        $scope.brandPdmReadyCache = {};
        $scope.OutsoleTechs = [];
        $scope.currencies = [];

        var globalPageNumber = 1;
        var globalPageSize = 50;

        $scope.windowGridHeight = function () {
            if (window.outerHeight >= 768) {
                return window.innerHeight - 315;
            } else {
                var size = $scope.totalRecords < $scope.pageSize ? $scope.totalRecords : $scope.pageSize;
                return size * gridOptions.rowHeight + 46;
            }
        };

        $scope.pagingOptions = [15, 25, 50, 100];

        $scope.onBtnBeg = function () {
            $scope.pageNumber = 1;
            $scope.onPageChanged(1);
        };

        $scope.onBtnEnd = function () {
            $scope.pageNumber = $scope.totalPages;
            $scope.onPageChanged($scope.totalPages);
        };

        $scope.onBtnPrev = function (e) {
            if (e > 1) {
                e = e - 1;
                $scope.pageNumber = e;
                $scope.onPageChanged(e);
            }
        };

        $scope.onBtnNext = function (e) {
            if (e < $scope.totalPages) {
                e = e + 1;
                $scope.pageNumber = e;
                $scope.onPageChanged(e);
            }
        };

        $scope.onPageChanged = function (e) {
            globalPageNumber = e;
            $scope.flashEditCosting.$pristine = false; //forces the search to get new results
            $scope.getCosting($scope.flashEditCosting.$invalid, $scope.searchForm);
        };

        $scope.onPageSizeChanged = function (e) {
            globalPageSize = e;
            globalPageNumber = 1;
            $scope.getCosting($scope.flashEditCosting.$invalid, $scope.searchForm);
        };

        $scope.exportData = function () {

            var reportName = 'PLM-Costing';

            var brandId = $scope.searchForm.brandId;
            
            if (brandId) {
                var brand = _.find($scope.brands,
                    function(b) {
                        return b.BrandId === brandId;
                    });
                if (brand) {
                    reportName += '-' + brand.BrandName;
                }
            }

            var seasonId = $scope.searchForm.seasonId;
            
            if (seasonId) {
                var season = _.find($scope.seasons,
                    function(s) {
                        return s.SeasonId === seasonId;
                    });
                if (season) {
                    reportName += '-' + season.SAPSeasonCode;
                }
            }
            
            var tempData = [];

            for (var i in $scope.gridData) {
                var row = $scope.gridData[i];
                var temp = {};

                temp.PrototypeSeasonalId = row.PrototypeSeasonalId != null ? row.PrototypeSeasonalId : '';
                temp.PrototypeName = row.PrototypeName != null ? row.PrototypeName : '';
                temp.StockNum = row.StockNum != null ? row.StockNum : '';
                temp.SAPSeasonCode = row.SAPSeasonCode != null ? row.SAPSeasonCode : '';
                temp.StatusName = row.StatusName != null ? row.StatusName : '';
                temp.Gender = row.Gender != null ? row.Gender : '';
                temp.FactName = row.FactName != null ? row.FactName : '';
                temp.CtryOfOrig = row.CtryOfOrig != null ? row.CtryOfOrig : '';
                temp.FactNameKy = row.FactNameKy != null ? row.FactNameKy : '';
                temp.FactoryGroupName = row.FactoryGroupName || "";
                temp.EstFFC = row.EstFFC != null ? row.EstFFC : '';
                temp.EstFfcCurr = row.EstFfcCurr != null ? row.EstFfcCurr : '';
                temp.FFC = row.FFC != null ? row.FFC : '';
                temp.FfcCurr = row.FfcCurr != null ? row.FfcCurr : '';
                temp.InitialPrototypeComplete =
                    row.InitialPrototypeComplete != null ? row.InitialPrototypeComplete : false;
                temp.InitialPrototypeCompleteDate = row.InitialPrototypeCompleteDate != null
                    ? $filter('date')(row.InitialPrototypeCompleteDate, 'MM/dd/yyyy')
                    : '';
                temp.InitialPrototypePrice = row.InitialPrototypePrice != null ? row.InitialPrototypePrice : '';
                temp.ISRComplete = row.ISRComplete != null ? row.ISRComplete : false;
                temp.ISRCompleteDate =
                    row.ISRCompleteDate != null ? $filter('date')(row.ISRCompleteDate, 'MM/dd/yyyy') : '';
                temp.ISRPrice = row.ISRPrice != null ? row.ISRPrice : '';
                temp.LDMComplete = row.LDMComplete != null ? row.LDMComplete : false;
                temp.LDMCompleteDate =
                    row.LDMCompleteDate != null ? $filter('date')(row.LDMCompleteDate, 'MM/dd/yyyy') : '';
                temp.LDMPrice = row.LDMPrice != null ? row.LDMPrice : '';
                temp.SMComplete = row.SMComplete != null ? row.SMComplete : false;
                temp.SMCompleteDate =
                    row.SMCompleteDate != null ? $filter('date')(row.SMCompleteDate, 'MM/dd/yyyy') : '';
                temp.SMPrice = row.SMPrice != null ? row.SMPrice : '';
                temp.ProductionComplete = row.SMFinalComplete != null ? row.SMFinalComplete : false;
                temp.ProductionDate =
                    row.SMFinalCmptDt != null ? $filter('date')(row.SMFinalCmptDt, 'MM/dd/yyyy') : '';
                temp.ProductionPrice = row.SMFinalPrice != null ? row.SMFinalPrice : '';
                temp.CostingCompl = row.CostingCompl != null ? row.CostingCompl : '';
                temp.ServFee = row.ServFee != null ? row.ServFee : '';
                temp.FfcPct = row.FfcPct != null ? row.FfcPct : '';
                temp.EstPurPrice = row.EstPurPrice != null ? row.EstPurPrice : '';
                temp.ActPurPrice = row.ActPurPrice != null ? row.ActPurPrice : '';

                if (!$rootScope.globals.currentUser.isFactoryUser) {
                    temp.WsPrice = row.WsPrice != null ? row.WsPrice : '';
                    temp.RetailPrice = row.RetailPrice != null ? row.RetailPrice : '';
                }

                tempData.push(temp);
            }

            alasql.promise(
                'SELECT * INTO XLSX("' + reportName + '.xlsx",{headers:true,sheetid:"Sheet1"}) FROM ?',
                [tempData]).then(function (data) {
                    //custom loader bar complete so we can make sure the grid is visible and rendered before hiding the loader
                    cfpLoadingBar.complete();
                }).catch(function (err) { });
        };

        $scope.saveEdits = function (rowEntity) {
            var cost = {
                InitialPrototypeComplete: rowEntity.InitialPrototypeComplete,
                ISRComplete: rowEntity.ISRComplete,
                LDMComplete: rowEntity.LDMComplete,
                SMComplete: rowEntity.SMComplete,
                SMFinalComplete: rowEntity.SMFinalComplete,
                InitialPrototypeCompleteDate: rowEntity.InitialPrototypeCompleteDate,
                ISRCompleteDate: rowEntity.ISRCompleteDate,
                LDMCompleteDate: rowEntity.LDMCompleteDate,
                SMCompleteDate: rowEntity.SMCompleteDate,
                SMFinalCmptDt: rowEntity.SMFinalCmptDt,
                InitialPrototypePrice: rowEntity.InitialPrototypePrice,
                ISRPrice: rowEntity.ISRPrice,
                LDMPrice: rowEntity.LDMPrice,
                SMPrice: rowEntity.SMPrice,
                SMFinalPrice: rowEntity.SMFinalPrice,
                PrototypeSeasonalId: rowEntity.PrototypeSeasonalId,
                PrototypeId: rowEntity.PrototypeId,
                PrototypeName: rowEntity.PrototypeName,
                SeasonId: rowEntity.SeasonId,
                SAPSeasonCode: rowEntity.SAPSeasonCode,
                StatusName: rowEntity.StatusName,
                Gender: rowEntity.Gender,
                StockNum: rowEntity.StockNum,
                FactName: rowEntity.FactName,
                CtryOfOrig: rowEntity.CtryOfOrig,
                FactNameKy: rowEntity.FactNameKy,
                EstFFC: rowEntity.EstFFC,
                FFC: rowEntity.FFC,
                EstFfcCurr: rowEntity.EstFfcCurr,
                FfcCurr: rowEntity.FfcCurr,
                CostingCompl: rowEntity.CostingCompl,
                CostingComplBy: $rootScope.globals.currentUser.userId,
                CostingComplDate: null,
                ServFee: rowEntity.ServFee,
                EstFfcPct: rowEntity.EstFfcPct,
                FfcPct: rowEntity.FfcPct,
                ActPurPrice: rowEntity.ActPurPrice,
                EstPurPrice: rowEntity.EstPurPrice,
                RetailPrice: rowEntity.RetailPrice,
                WsPrice: rowEntity.WsPrice,
                OutsoleTechCode: rowEntity.OutsoleTechCode
            };

            return CostingService.updateProtoCosting(cost).then(function (response) {
                if (response) {
                    rowEntity.ActPurPrice = response.ActPurPrice;
                    rowEntity.EstPurPrice = response.EstPurPrice;
                    rowEntity.ServFee = response.ServFee;
                    rowEntity.FfcPct = response.FfcPct;
                    rowEntity.EstFfcPct = response.EstFfcPct;
                    rowEntity.FfcCurr = response.FfcCurr;
                    rowEntity.EstFfcCurr = response.EstFfcCurr;

                    GridUtil.updateRollbackData(rowEntity);

                    gridOptions.api.updateRowData({
                        update: [rowEntity]
                    });

                    gridOptions.api.refreshCells({ force: true });

                    console.log("success");
                }
            },
                function (error) {
                    showError(error);

                    GridUtil.rollback(rowEntity, gridOptions);

                    console.log("error");

                    return $q.reject();
                });
        };

        $scope.getSeason = function (brandId) {
            if (brandId) {
                SeasonService.getSeasonsByBrand(brandId).then(function (response) {
                    if (response) {
                        $scope.seasons = response;
                    }
                });
            }
        };

        function setScopeLevelSearchInfo(response) {

            $scope.totalRecords = response.totalRecords;
            $scope.pageSize = response.pageSize;
            $scope.pageNumber = response.currentPage;
            $scope.totalPages = response.totalPages;

            $scope.lastRecord = $scope.pageNumber == $scope.totalPages
                ? $scope.totalRecords
                : $scope.pageNumber * $scope.pageSize;

            $scope.firstRecord = $scope.pageNumber == $scope.totalPages
                ? (($scope.pageNumber - 1) * $scope.pageSize) + 1
                : $scope.lastRecord - $scope.pageSize + 1;

            $scope.columnDefs = $scope.getColumnDefs(response);
        }

        function setGridSorting(columnDefs) {

            var colId = $scope.searchForm.sortColumn;
            var sort = $scope.searchForm.sortDirection;

            GridUtil.setSort(columnDefs, colId, sort);
        }

        function renderGrid(gridDiv, columnDefs, searchResults) {
            gridOptions.columnDefs = columnDefs;

            if (gridDiv.children.length == 0) {
                new agGrid.Grid(gridDiv, gridOptions);
            } else {
                gridOptions.api.setColumnDefs(gridOptions.columnDefs);
            }

            gridOptions.api.setRowData(searchResults);
            gridOptions.api.hideOverlay();
        };

        $scope.getCosting = function (formInvalid, searchForm, exportResults) {

            if (formInvalid) {
                $scope.flashEditCosting.$submitted = true;
                $scope.flashEditCosting.$invalid = true;
                return;
            }

            var search = {
                brandId: searchForm.brandId ? searchForm.brandId : null,
                seasonId: searchForm.seasonId ? searchForm.seasonId : null,
                projectName: searchForm.projectName ? searchForm.projectName : null,
                prototypeSeasonalId: searchForm.prototypeSeasonalId ? searchForm.prototypeSeasonalId : null,
                patternName: searchForm.patternName ? searchForm.patternName : null,
                statusId: searchForm.statusId ? searchForm.statusId : null,
                genderKey: searchForm.genderKey ? searchForm.genderKey : null,
                factoryKey: searchForm.factoryKey ? searchForm.factoryKey : null,
                factoryName: searchForm.factoryName ? searchForm.factoryName : null,
                outsoleNumber: searchForm.outsoleNumber ? searchForm.outsoleNumber : null,
                outsoleName: searchForm.outsoleName ? searchForm.outsoleName : null,
                costingCompl: searchForm.costingCompl == 0 ? false : searchForm.costingCompl == 1 ? true : null,
                stockNum: searchForm.stockNum ? searchForm.stockNum : null,
                productTypeId: searchForm.productTypeId ? searchForm.productTypeId : null,
                divisionKey: searchForm.divisionKey ? searchForm.divisionKey : null,
                divisionName: searchForm.divisionName ? searchForm.divisionName : null,
                pageNumber: exportResults ? '1' : globalPageNumber,
                pageSize: exportResults ? -1 : globalPageSize,
                sortColumn: searchForm.sortColumn,
                sortDirection: searchForm.sortDirection
            };

            //start page loader
            cfpLoadingBar.start();
            model.exportResults = exportResults;

            var gridDiv = document.querySelector('#myGrid');

            CostingService.getProtoCostingList(search).then(function (response) {
                if (!response || response.results.length === 0) {
                    cfpLoadingBar.complete();
                    showWarning('No Costing data was found matching this search criteria.');
                    return;
                }

                if (model.exportResults) {
                    $scope.gridData = response.results;
                    $scope.exportData();
                    return;
                }

                setScopeLevelSearchInfo(response);

                setGridSorting($scope.columnDefs);

                GridUtil.enableRollback(response.results);

                renderGrid(gridDiv, $scope.columnDefs, response.results);

                //show the grid, hide search form, mark page complete on load
                $scope.showGrid = true;

                //custom loader bar complete so we can make sure the grid is visible and rendered before hiding the loader
                cfpLoadingBar.complete();

                //search was ran to accomodate the below comment...
                //set search page to pristine so if we go back and refine, but change nothing, we can come back to the grid right away
                $scope.flashEditCosting.$setPristine();
            }, function (error, status) {
                showError(
                    'There was an error retrieving Costing Data. Please contact the system administrator');
            });
        };

        $scope.toggleSearchAndResults = function () {
            if ($scope.showGrid) {
                $scope.showGrid = false;
            } else {
                $scope.showGrid = true;
            }
        };

        $scope.$on('$dropletReady',
            function whenDropletReady() {
                $scope.documentInterface.allowedExtensions(['.xlsx', '.xls']);
                $scope.documentInterface.defineHTTPSuccess([/2.{2}/]);
                $scope.documentInterface.useArray(true);
            });

        $scope.selectDoc = function (e) {
            if (e.files.length > 0)
                uploadDoc(e.files[0], 'browse');
        };

        $scope.addDoc = function (file) {
            if (file)
                uploadDoc(file.file, 'dragdrop');
        };

        function valueConvert(n) {
            if (n !== '' && n !== null && n !== true && n !== false) {
                if (!isNaN(n)) {
                    return parseInt(n);
                }
            }
            if (n == null || n == '') {
                return '';
            }
            return n;
        }

        function getCurrencySymbol(currencyKey) {
            var symbol = $;
            angular.forEach($scope.currencies,
                function (currency) {
                    if (currency.CurrencyKey === currencyKey) {
                        symbol = $filter('currencySymbol')(currency);
                    }
                });

            return symbol;
        }

        var currencyFieldMap = {
            FFC: 'FfcCurr',
            EstFFC: 'EstFfcCurr',
            FfcPct: 'FfcCurr',
            EstFfcPct: 'EstFfcCurr',
            ActPurPrice: 'FfcCurr',
            EstPurPrice: 'EstFfcCurr',

            asArray: function () {
                return ['FFC', 'EstFFC', 'FfcPct', 'EstFfcPct', 'ActPurPrice', 'EstPurPrice'];
            }
        };

        function currencyFormatter(params) {
            var currencyField = currencyFieldMap[params.colDef.field];
            var symbol = currencyField ? getCurrencySymbol(params.data[currencyField]) : '$';
            return $filter('currency')(params.value, symbol);
        }

        function percentFormatter(params) {
            return $filter('percentage')(params.value, 1);
        }

        function currencySelectionEditor(field) {
            return function (params) {
                var select = document.createElement('select');
                select.className = 'grid-select';
                var defaultOption = document.createElement('option');
                defaultOption.value = '';
                defaultOption.text = '---Select---';
                select.appendChild(defaultOption);
                for (var i in $scope.currencies) {
                    var option = document.createElement('option');
                    option.value = $scope.currencies[i].CurrencyKey;
                    option.text = $scope.currencies[i].CurrencyKey + ' (' + $scope.currencies[i].ShortName + ')';
                    if (params.value === $scope.currencies[i].CurrencyKey) {
                        option.selected = true;
                    }
                    select.appendChild(option);
                }
                select.addEventListener('change',
                    function () {
                        params.data[field] = this.value;
                        gridOptions.api.refreshCells({ force: true, columns: currencyFieldMap.asArray() });
                        $scope.saveEdits(params.data);
                    });
                return select;
            };
        }

        function ffcEditor() {
        }

        ffcEditor.prototype.init = function (params) {
            this.params = params;
            this.eInput = document.createElement('input');
            this.eInput.className = 'ag-cell-edit-input';
            this.eInput.maxLength = '8'; //set maxlength for editing 8 is max that the DB will allow!
            this.eInput.type = 'text';

            //assignment back from API changes or a direct input change
            if (params.charPress) {
                var number = parseInt(params.charPress);
                if (!isNaN(number))
                    this.eInput.value = params.charPress;
            } else {
                this.eInput.value = params.value;
            }

            this.eInput.addEventListener('keydown',
                function (event) {
                    //backspace, tab, up, down, left, right arrows, enter, period, period_num_pad,
                    var allowedKeys = [8, 13, 37, 38, 39, 40, 46, 190, 110];
                    var allowedMetaKeys = [65, 86, 67, 88, 116, 82, 90];
                    //Ctrl, Ctrl + A, Ctrl + C, Ctrl + V, Ctrl + X, Ctrl + R, Ctrl + Z
                    var eventKey = event.key;

                    //no spacebar
                    if (eventKey == ' ') {
                        eventKey = 'x';
                        //just defaulting it to a value that isnt allowed
                    }

                    if (isNaN(eventKey)) {
                        var ctrlMeta = event.ctrlKey == true || event.metaKey == true;

                        //if ctrl isnt being pressed
                        if (!ctrlMeta) {
                            if (allowedKeys.indexOf(event.keyCode) == -1) {
                                event.preventDefault();
                            }
                            if (allowedMetaKeys.indexOf(event.keyCode) > -1) {
                                event.preventDefault();
                            }
                        }
                    }
                });
        };

        ffcEditor.prototype.getGui = function () {
            return this.eInput;
        };

        ffcEditor.prototype.afterGuiAttached = function () {
            var l = this.eInput.value ? this.eInput.value.toString().length : '';

            this.eInput.value = this.eInput.value;

            if (!this.params.charPress) {
                this.eInput.setSelectionRange(0, l);
            } else {
                if (l !== '') {
                    this.eInput.setSelectionRange(l, l);
                }
            }

            this.eInput.focus();
        };

        ffcEditor.prototype.getValue = function () {
            return this.eInput.value;
        };

        function outsoleTechRenderer(params) {
            var select = document.createElement('select');
            select.className = 'grid-select';
            var defaultOption = document.createElement('option');
            defaultOption.value = '';
            defaultOption.text = '---Select---';
            select.appendChild(defaultOption);
            for (var i in $scope.OutsoleTechs) {
                var option = document.createElement('option');
                option.value = $scope.OutsoleTechs[i].OutsoleTechCode;
                option.text = $scope.OutsoleTechs[i].OutsoleTechDesc;
                if (params.value === $scope.OutsoleTechs[i].OutsoleTechCode) {
                    option.selected = true;
                }
                select.appendChild(option);
            }
            select.addEventListener('change',
                function () {
                    params.data.OutsoleTechCode = this.value;
                    $scope.saveEdits(params.data);
                });
            return select;
        }

        //NOTE: Much of this milestone logic is duplicated in prototype.ctrl.js. If changes are made here, they probably need to be made there also.
        var milestoneFieldMap = {
            InitialPrototypeComplete: ['InitialPrototypeCompleteDate', 'InitialPrototypePrice'],
            ISRComplete: ['ISRCompleteDate', 'ISRPrice'],
            LDMComplete: ['LDMCompleteDate', 'LDMPrice'],
            SMComplete: ['SMCompleteDate', 'SMPrice'],
            SMFinalComplete: ['SMFinalCmptDt', 'SMFinalPrice'],

            asArray: function () {
                return ['InitialPrototypeComplete', 'ISRComplete', 'LDMComplete', 'SMComplete'];
            }
        };

        function createCheckbox(params) {
            var field = params.column.colDef.field;
            var data = params.data;

            var chk = document.createElement('input');
            chk.type = 'checkbox';
            chk.className = 'default';
            chk.checked = data[field] === true;
            chk.name = field;

            params.eGridCell.addEventListener('focus',
                function () {
                    chk.focus();
                });

            chk.addEventListener('keydown',
                function (event) {
                    if (event.key === 13) {
                        event.preventDefault();
                    }
                });

            data['set' + field + 'Disabled'] = function (val) {
                chk.disabled = val;
            };

            data['set' + field + 'Checked'] = function (val) {
                data[field] = val;
                chk.checked = val;
            };

            return chk;
        }

        function smFinalCompleteRenderer(params) {
            var chk = createCheckbox(params);
            var field = params.column.colDef.field;
            var data = params.data;

            chk.addEventListener('change',
                function () {
                    data[field] = this.checked;

                    milestoneChecked(params.data, field).then(function (checked) {
                        if (!checked) {
                            data['set' + field + 'Checked'](false);
                        }

                        setMilestoneAccess(params);
                        $scope.saveEdits(data);
                    });
                });

            setMilestoneAccess(params);

            return chk;
        }

        function milestoneRenderer() { }

        milestoneRenderer.prototype.init = function (params) {
            var chk = createCheckbox(params);
            var field = params.column.colDef.field;
            var data = params.data;

            chk.addEventListener('change',
                function () {
                    data[field] = this.checked;

                    milestoneChecked(params.data, field).then(function (checked) {
                        if (checked) {
                            var milestoneFields = milestoneFieldMap.asArray();
                            var i = milestoneFields.length - 1;
                            var checkthis = false;
                            var checkall = !milestoneFieldMap.hasOwnProperty(field);
                            while (i > -1) {
                                if (data[milestoneFields[i]] !== true && (checkthis || checkall)) {
                                    data['set' + milestoneFields[i] + 'Checked'](true);
                                    milestoneChecked(data, milestoneFields[i]);
                                } else if (milestoneFields[i] === field) {
                                    checkthis = true;
                                }
                                i--;
                            }
                        } else {
                            data['set' + field + 'Checked'](false);
                        }
                        setMilestoneAccess(params);
                        $scope.saveEdits(data);
                    });
                });

            setMilestoneAccess(params);

            this.chk = chk;
            this.field = field;
        };

        milestoneRenderer.prototype.getGui = function () {
            return this.chk;
        };

        milestoneRenderer.prototype.refresh = function (params) {
            this.chk.checked = params.data[this.field] === true;
        };

        $scope.cellEditors = {
            'ffcEditor': ffcEditor
        };

        $scope.cellRenderers = {
            'milestoneRenderer': milestoneRenderer,
            'smFinalCompleteRenderer': smFinalCompleteRenderer,
            'outsoleTechRenderer': outsoleTechRenderer,
            'estFfcCurr': currencySelectionEditor('EstFfcCurr'),
            'ffcCurr': currencySelectionEditor('FfcCurr')
        };

        $scope.valueFormatters = {
            'percentFormatter': percentFormatter,
            'currencyFormatter': currencyFormatter
        };

        function milestoneChecked(data, field) {
           
            var completeProp = field;

            var deferred = $q.defer();
           
            var checked = data[completeProp] === true;
            

            if (!$scope.brandPdmReadyCache.hasOwnProperty(data.BrandId.toString())) {
                BrandService.isBrandPDMReady(data.BrandId).then(function (response) {
                    $scope.brandPdmReadyCache[data.BrandId.toString()] = response;
                    milestoneChecked(data, field).then(function (checked) {
                        deferred.resolve(checked);
                    });
                });
            } else {
                if (checked) {
                    if ($scope.brandPdmReadyCache[data.BrandId.toString()] === true) {
                        PdmServices.calcPdmPrice(data.PrototypeId, data.SeasonId).then(function (response) {
                            var success = trySetMilestoneValues(data, field, true, response);
                            deferred.resolve(success);
                        });
                    } else {
                        var success = trySetMilestoneValues(data, field, true, data.FFC);
                        deferred.resolve(success);
                    }
                } else {
                    trySetMilestoneValues(data, field, false, null);
                    deferred.resolve(false);
                }
            }
            return deferred.promise;
        }

        function trySetMilestoneValues(data, field, checked, price) {
            console.log($filter('date')(new Date(), 'yyyy-MM-dd'))
            if (checked === true && field === "CostingCompl") {
                if (!data.FactNameKy || data.FactNameKy.trim().length === 0 || !data.FactName || data.FactName.trim().length === 0) {
                    showAlert("Costing Complete can't be checked because a factory has not yet been assigned!");
                    return false;
                }
            }
            if (checked && (!price || price <= 0)) {
                showAlert('Cost (FFC) must be entered before you can check off a milestone!');
                return false;
            }

            if (!milestoneFieldMap.hasOwnProperty(field)) {
                return checked;
            }

            var dateProp = milestoneFieldMap[field][0];
            var priceProp = milestoneFieldMap[field][1];

            if (price) {
                data.FFC = price;
                data[priceProp] = price;
                data[dateProp] = $filter('date')(new Date(), 'yyyy-MM-dd');
            } else {
                data[priceProp] = null;
                data[dateProp] = null;
            }

            return true;
        }

        function setMilestoneAccess(params) {
            var data = params.data;

            var smDisabled = data.CostingCompl === true;
            var ldmDisabled = data.SMComplete === true || smDisabled;
            var isrDisabled = data.LDMComplete === true || ldmDisabled;
            var initialPrototypeDisabled = data.ISRComplete === true || isrDisabled;

            if (data.setSMCompleteDisabled)
                data.setSMCompleteDisabled(smDisabled);
            if (data.setLDMCompleteDisabled)
                data.setLDMCompleteDisabled(ldmDisabled);
            if (data.setISRCompleteDisabled)
                data.setISRCompleteDisabled(isrDisabled);
            if (data.setInitialPrototypeCompleteDisabled)
                data.setInitialPrototypeCompleteDisabled(initialPrototypeDisabled);
        }

        var globalRowHeight = 30;

        var gridOptions = {
            rowHeight: globalRowHeight,
            enableColResize: true,
            enableFilter: false,
            enableSorting: false,
            enableServerSideSorting: true,
            paginationPageSize: globalPageSize,
            suppressContextMenu: true,
            suppressMultiSort: true,
            suppressSorting: false,
            suppressDragLeaveHidesColumns: true,
            suppressMovableColumns: true, //set to false to stop from moving colums
            suppressRowHoverClass: true,
            suppressColumnMoveAnimation: true,
            suppressColumnVirtualisation: true,
            showToolPanel: false,
            stopEditingWhenGridLosesFocus: true,
            onCellValueChanged: function (params) {
                var oldValue = valueConvert(params.oldValue);
                var newValue = valueConvert(params.newValue);
                if (oldValue !== newValue) {
                    $scope.saveEdits(params.data);
                }
            },
            onCellClicked: function (event) {
                if (event.colDef.field === 'PrototypeName') {
                    $state.go('colorway', { 'prototypeSeasonalId': event.data.PrototypeSeasonalId });
                }
            },

            onSortChanged: function (e) {
                var sortObj = gridOptions.api.getSortModel();
                $scope.searchForm.sortColumn = sortObj.length ? sortObj[0].colId : "";
                $scope.searchForm.sortDirection = sortObj.length ? sortObj[0].sort : "";

                $scope.getCosting($scope.flashEditCosting.$invalid, $scope.searchForm);
            }
        };

        $scope.getColumnDefs = function (response) {
            var columnDefs = [];
            response.columnGroups.totalColumns = response.totalColumns;

            angular.forEach(response.columnGroups,
                function (colGroup) {
                    angular.forEach(colGroup.columns,
                        function (col) {
                            if (col.cellEditor) {
                                col.cellEditor = $scope.cellEditors[col.cellEditor];
                            }

                            if (col.cellRenderer) {
                                col.cellRenderer = $scope.cellRenderers[col.cellRenderer];
                            }

                            if (col.valueFormatter) {
                                col.valueFormatter = $scope.valueFormatters[col.valueFormatter];
                            }

                            columnDefs.push(col);
                        });
                });

            return columnDefs;
        };

        function clearFileSelect() {
            $scope.documentInterface = {};
            document.getElementById('file').value = null;
        }

        function uploadDoc(file, source) {
            var ext = file.name.substr(file.name.lastIndexOf('.') + 1);
            if (ext != 'xls' && ext != 'xlsx') {
                showError('Please upload an Excel file (.xls or .xlsx)');
                clearFileSelect();
                return;
            }

            CostingService.uploadMassPrototypeCostingDocument(file)
                .then(function (response) {
                    toaster.pop({
                        type: 'success',
                        title: 'File uploaded!',
                        body: 'You will be notified by email when processing is complete.',
                        timeout: 2000
                    });
                    clearFileSelect();
                },
                    function (error, status) {
                        toaster.pop({
                            type: 'error',
                            title: 'Forecasting upload failed',
                            body: 'Contact system administrator.',
                            timeout: 5000
                        });
                        clearFileSelect();
                    });
            $scope.showGrid = false;
        }

        function getPage() {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    $scope.searchForm = {};
                    $scope.brands = response.brands;
                    $scope.seasons = response.seasons;
                    $scope.searchForm.brandId = response.brandId;
                    $scope.searchForm.seasonId = response.seasonId;
                    $scope.searchForm.divisionKey = response.divisionKey;
                } else {
                    console.log('Error getting shared data');
                }
            });

            $scope.showGrid = false;
            getGenders();
            getOutsoles();
            getProductTypes();
            getDivisions();
        };

        function getOutsoleTechs() {
            PrototypeService.GetOutsoleTechs().then(function (techs) {
                $scope.OutsoleTechs = techs;
            });
        }

        function getCurrencies() {
            SearchHelpService.searchCurrencies().then(function (currencies) {
                $scope.currencies = currencies;
            });
        }

        function getGenders() {
            PatternService.getGenders('', 0).then(function (response) {
                if (response) {
                    $scope.genders = response;
                }
            });
        }

        function getOutsoles() {
            PatternService.getOutsoles().then(function (response) {
                if (response) {
                    $scope.outsoles = response;
                }
            });
        }

        function getProductTypes() {
            PrototypeService.getProductTypes().then(function (response) {
                if (response) {
                    $scope.productTypes = response;
                }
            });
        }

        function getDivisions() {
            PrototypeService.getDivisions(0).then(function (response) {
                if (response) {
                    $scope.divisions = response;
                }
            });
        }

        function showWarning(msg, title) {
            showToast('warning', title ? title : 'Alert!', msg, 5000);
        }

        function showError(msg, title) {
            showToast('error', title ? title : 'Error!', msg, 5000);
        }

        function showSuccess(msg, title) {
            showToast('success', title ? title : 'Success!', msg, 5000);
        }

        function showAlert(msg, title) {
            showToast('Alert', title ? title : 'Alert!', msg, 5000);
        }

        function showToast(type, title, body, timeout) {
            toaster.pop({
                type: type,
                title: title,
                body: body,
                timeout: timeout
            });
        }

        //model.init();
    }
}
)();
